import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { fmtDMY } from "@/lib/format";
import { PenLine, CheckCircle2, Clock } from "lucide-react";

export default function SignTimesheetCard({ task, onSign }) {
  const { t } = useTranslation();
  if (!task?.due) return null;
  const signed = task.signed;
  return (
    <div
      className={`rounded-xl border-2 p-5 ${signed ? "border-emerald-200 bg-emerald-50/60 opacity-80" : "border-indigo-300 bg-indigo-50/60"}`}
      data-testid="sign-timesheet-task"
    >
      <div className="flex items-start justify-between gap-3">
        <div>
          <h3 className="font-display text-2xl font-bold leading-tight">{t("Sign your timesheet")}</h3>
          <p className="mt-1 text-sm text-muted-foreground">
            {task.reason === "period_end"
              ? t("Last day of the pay period — check your times for the week ending {{date}} and sign.", { date: fmtDMY(task.week_end) })
              : t("Your last rostered day this pay period — check your times for the week ending {{date}} and sign.", { date: fmtDMY(task.week_end) })}
          </p>
        </div>
        <span className="inline-flex shrink-0 items-center gap-1 rounded-md bg-indigo-100 px-2 py-1 text-xs font-semibold text-indigo-700" data-testid="sign-task-badge">
          <PenLine className="h-3.5 w-3.5" /> {t("Task")}
        </span>
      </div>
      <div className="mt-2 flex items-center gap-1.5 text-sm text-muted-foreground">
        <Clock className="h-4 w-4" /> {t("No time recorded")}
      </div>
      <div className="mt-4">
        {signed ? (
          <div className="flex items-center justify-center gap-2 rounded-lg bg-emerald-100 py-3 text-base font-bold text-emerald-700" data-testid="sign-task-done">
            <CheckCircle2 className="h-5 w-5" /> {t("Timesheet signed")}
          </div>
        ) : (
          <Button onClick={onSign} className="k-press h-14 w-full gap-2 text-lg font-bold" data-testid="sign-task-open">
            <PenLine className="h-5 w-5" /> {t("Check times & sign")}
          </Button>
        )}
      </div>
    </div>
  );
}
